import type { Metric } from "@unbox/api";
import type { ReportTemplate } from "@/pages/reports/types";

export const REPORT_TEMPLATES: ReportTemplate[] = [
  {
    id: "product-gmv-revenue-source",
    name: "Product GMV by revenue source",
    description:
      "Track revenue performance across LIVE streams, Short Video, and Product Card channels with weekly granularity.",
    category: "Revenue",
    metrics: ["gmv"] satisfies Metric[],
    layout: "bar",
  },
  {
    id: "creator-community-health",
    name: "Creator Community Health",
    description:
      "Monitor creator activity trends with four key segments: New creators joining, Active creators, Dormant creators who stopped posting, and Reactivated creators coming back.",
    category: "Creators",
    metrics: ["creatorRetention"] satisfies Metric[],
    layout: "bar",
  },
  {
    id: "content-analysis",
    name: "Hook Content Analysis",
    description:
      "Track content hook performance weekly to understand what resonates with your audience. View GMV trends over time for each hook type.",
    category: "Content",
    metrics: ["gmv"] satisfies Metric[],
    layout: "chart",
  },
  {
    id: "content-efficiency",
    name: "Content Efficiency",
    description:
      "Measure GPM per video and videos posted to identify Analyse whether video quantity or video quality is driving performance.",
    category: "Content",
    metrics: ["videos", "gpm"] satisfies Metric[],
    layout: "chart",
  },
  {
    id: "pattern-analysis",
    name: "Hook Pattern Analysis",
    description:
      "View content hook statistics to understand what resonates with your audience. Analyze GMV, video count, and view performance across different hooks.",
    category: "Content",
    metrics: ["gmv", "videos", "views"] satisfies Metric[],
    layout: "table",
  },
];
